import { defineMessages } from 'react-intl';

type MessageKeys = 'shareUpToMessageLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		shareUpToMessageLabel: {
			id: 'conversation-assistant.common.message-footer-buttons.share-response.shareUpToMessageMessages.shareUpToMessageLabel',
			defaultMessage: 'Share chat up to this point',
			description:
				'Tooltip and accessible label for the button that shares the conversation up to and including this message.',
		},
	});

export default message;
